export const MULTI_PURPOSE_STATUS = {
    IN_ACTIVE: 0,
    ACTIVE: 1,
    PAYMENT_NOT_DONE: 2,
    PAYMENT_PARTIAL: 3,
    PAYMENT_COMPLETED: 4,
    REVERSED: 5,

}